module.exports = __webpack_public_path__ + "img/SDC-alt.21e9f02c.svg";